import Vue from "vue";

const getDefaultState = () => {
  return {
    groupes: [],
    groupesDeSuperviseur: [],
    groupesDeRegions: [],
    groupesDeRegionsScroll: [],
    startScroll: null,
    groupesRequest: [],
    itemById: { localisation: {} },
    disable_next: false,
    disable_prev: false,
    //Save first document in snapshot of items received
    firstInResponse: [],
    //Save last document in snapshot of items received
    lastInResponse: [],
    //Keep the array of first document of previous pages
    prev_start_at: [],
    //Maintain the count of clicks on Next Prev button
    pagination_clicked_count: 0,
    paginationSize: 10,
    //field: "localisation.ll_region",
    field: "email",
    whereField: "active",
    whereValue: "0",
    collection: "groupes",
  };
};
const state = getDefaultState();

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
    console.log("Groupe RESET_STATE");
    console.log("Nombre : ", state.groupes.length);
  },
  SET_GROUPES_DE_REGIONS(state, payload) {
    state.groupesDeRegions = payload;
  },
  SET_GROUPES_DE_REGIONS_SCROLL(state, payload) {
    state.groupesDeRegionsScroll = payload;
    //console.log("SET_GROUPES_DE_REGIONS_SCROLL :", payload);
  },
  SET_START_SCROLL(state, payload) {
    //console.log("SET_START_SCROLL: ", payload);
    state.startScroll = payload;
  },

  SET_GROUPES_DE_SUPERVISEUR(state, payload) {
    state.groupesDeSuperviseur = payload;
  },
  SET_groupesRequest(state, payload) {
    state.groupesRequest = payload;
  },
  SET_LISTE_GROUPES(state, payload) {
    state.groupes = payload;
  },

  SET_DISABLE_NEXT(state, payload) {
    state.disable_next = payload;
  },
  SET_DISABLE_PREV(state, payload) {
    state.disable_prev = payload;
  },

  SET_ITEM_BY_ID(state, payload) {
    state.itemById = payload;
  },
  SET_firstInResponse(state, payload) {
    state.firstInResponse = payload;
  },
  SET_lastInResponse(state, payload) {
    state.lastInResponse = payload;
  },
  SET_prev_start_at(state, payload) {
    state.prev_start_at = payload;
  },
  SET_pagination_clicked_count(state, payload) {
    state.pagination_clicked_count = payload;
  },
  SET_prev_start_at(state, payload) {
    state.prev_start_at = payload;
  },
  ADD_ONE_ITEM_TO_GROUPES_DE_SUPERVISEUR(state, payload) {
    state.groupesDeSuperviseur.push(payload);
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  addOneItem({ commit }, item) {
    commit("ADD_ONE_ITEM_TO_GROUPES_DE_SUPERVISEUR", item);
    console.log("added to Vuex Groupes du superviseur", item);
  },
  async GetGroupesDeSuperviseur({ commit, dispatch }, objet) {
    console.log("objet.project.id", objet.project.id);

    // start requête
    commit("SET_GROUPES_DE_SUPERVISEUR", []);
    commit("Loading/START_BUSY_STATE", "groupes.store.js", { root: true });

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection("groupes")
      .where("responsable", "==", objet.userId)
      .where("projectList", "array-contains", objet.project.id)
      .orderBy("nom_groupe")
      .get()
      .then(
        (snapshot) => {
          snapshot.docChanges().forEach(function (change) {
            commit("SET_GROUPES_DE_SUPERVISEUR", []);
          });

          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste dans Groupes");
            commit("Pending/START_PENDING_STATE", null, { root: true });
          } else {
            console.log("tout est synchronisé dans Groupes");
            commit("Pending/END_PENDING_STATE", null, { root: true });
          }
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_GROUPES_DE_SUPERVISEUR", elems);
            commit("Loading/END_BUSY_STATE", "groupes.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("Loading/END_BUSY_STATE", "groupes.store.js", {
            root: true,
          });
        }
      );
  },
  async GetGroupesDeRegions({ commit }, arrayRegions) {
    if (arrayRegions) {
      let self = this;
      const groupes = [];
      self._vm.$vloading.show();
      commit("SET_GROUPES_DE_REGIONS", []);
      this._vm.$firebase
        .firestore()
        .collection("groupes")
        .where("id_region", "in", arrayRegions)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            groupes.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          commit("SET_GROUPES_DE_REGIONS", groupes);
          self._vm.$vloading.hide();
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    }
  },
  async GetGroupesDeRegionsScrollInitial(
    { commit, dispatch, rootState },
    arrayRegions
  ) {
    if (arrayRegions) {
      let self = this;
      commit("SET_GROUPES_DE_REGIONS_SCROLL", []);
      commit("SET_START_SCROLL", rootState.Groupes.startScroll);
      const groupes = [];
      self._vm.$vloading.show();

      var first = this._vm.$firebase
        .firestore()
        .collection("groupes")
        .where("id_region", "in", arrayRegions)
        .orderBy("date_insert_gp")
        .limit(10);

      first.get().then((documentSnapshots) => {
        var lastVisible = documentSnapshots.docs[
          documentSnapshots.docs.length - 1
        ].data();
        //console.log("last", lastVisible);
        documentSnapshots.docs.forEach((doc) => {
          //console.log(doc.id, " => ", doc.data());
          groupes.push({
            ...doc.data(),
            id: doc.id,
          });
        });
        commit("SET_GROUPES_DE_REGIONS_SCROLL", groupes);
        commit("SET_START_SCROLL", lastVisible);
      });
    }
  },
  async GetGroupesDeRegionsScroll(
    { commit, dispatch, rootState },
    arrayRegions
  ) {
    let self = this;
    const groupes = rootState.Groupes.groupesDeRegionsScroll;
    const latestScrollGroup = rootState.Groupes.startScroll;
    console.log("nuullll ve?", rootState.Groupes.startScroll);
    self._vm.$vloading.show();

    var next = this._vm.$firebase
      .firestore()
      .collection("groupes")
      .where("id_region", "in", arrayRegions)
      .orderBy("date_insert_gp")
      .startAfter(latestScrollGroup.date_insert_gp)
      .limit(10);
    next.get().then((documentSnapshots) => {
      var lastVisible = documentSnapshots.docs[
        documentSnapshots.docs.length - 1
      ].data();
      console.log("last new", lastVisible);
      documentSnapshots.docs.forEach((doc) => {
        //console.log(doc.id, " => ", doc.data());
        groupes.push({
          ...doc.data(),
          id: doc.id,
        });
      });
      commit("SET_GROUPES_DE_REGIONS_SCROLL", groupes);
      commit("SET_START_SCROLL", lastVisible);
    });

    self._vm.$vloading.hide();
  },

  SetItemById({ commit }, idGroupe) {
    commit("Loading/START_BUSY_STATE", "SetItemById", { root: true });
    var docRef = this._vm.$firebase
      .firestore()
      .collection("groupes")
      .doc(idGroupe);
    docRef
      .get()
      .then(function (doc) {
        if (doc.exists) {
          const objet = { ...doc.data(), id: doc.id };
          /* id: doc.id, */
          //console.log("Document data:", doc.data());
          commit("SET_ITEM_BY_ID", objet);
          commit("Loading/END_BUSY_STATE", "SetItemById", { root: true });
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch(function (error) {
        console.log("Error getting document:", error);
      });
  },

  async GetAllGroupeRequest({ commit, dispatch }) {
    // start requête
    commit("RESET_STATE");
    commit("SET_groupesRequest", []);
    commit("Loading/START_BUSY_STATE", "GetAllGroupeRequest", { root: true });
    this._vm.$firebase
      .firestore()
      .collection("groupesRequest")
      //.limit(this.state.Groupes.paginationSize)
      .get()
      .then(
        (snapshot) => {
          let elems = [];
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            console.log("No Data Available");
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = "Pas d'éléments";
            commit("Snackbar/SET_SNACKBAR", snack, { root: true });

            return false;
          } else {
            commit("SET_groupesRequest", elems);

            commit(
              "Loading/END_BUSY_STATE",
              "groupesRequest Groupes.store.js",
              {
                root: true,
              }
            );
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "roupesRequest Groupes.store.js", {
            root: true,
          });
        }
      );
  },

  async GetAllGroupes({ commit, dispatch }) {
    // start requête
    commit("RESET_STATE");
    commit("SET_LISTE_GROUPES", []);
    commit("Loading/START_BUSY_STATE", "GetAllGroupes", { root: true });
    this._vm.$firebase
      .firestore()
      .collection(this.state.Groupes.collection)
      .orderBy(this.state.Groupes.field)
      //.limit(this.state.Groupes.paginationSize)
      .get()
      .then(
        (snapshot) => {
          let elems = [];
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });
          commit("SET_prev_start_at", []);

          if (!elems) {
            console.log("No Data Available");
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = "Pas d'éléments";
            commit("Snackbar/SET_SNACKBAR", snack, { root: true });
            commit("SET_DISABLE_PREV", false);
            return false;
          } else {
            commit("SET_firstInResponse", elems[0]);
            commit("SET_lastInResponse", elems[elems.length - 1]);
            commit("SET_pagination_clicked_count", 0);
            commit("SET_DISABLE_NEXT", false);
            commit("SET_DISABLE_PREV", false);

            //Push first item to use for Previous action
            let prev_start_at = [];
            prev_start_at.push(elems[0]);
            commit("SET_prev_start_at", prev_start_at);

            commit("SET_LISTE_GROUPES", elems);
            commit("Loading/END_BUSY_STATE", "Groupes.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });

          commit("Loading/END_BUSY_STATE", "Groupes.store.js", {
            root: true,
          });
        }
      );
  },

  async nextPage({ commit }) {
    let elems = [];
    let self = this;

    commit("SET_DISABLE_NEXT", true);
    await this._vm.$firebase
      .firestore()
      .collection(this.state.Groupes.collection)
      .orderBy(this.state.Groupes.field)
      .startAfter(this.state.Groupes.lastInResponse.email)
      .limit(this.state.Groupes.paginationSize)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          commit("SET_LISTE_GROUPES", elems);

          if (!elems.length) {
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = "Pas d'éléments";
            commit("Snackbar/SET_SNACKBAR", snack, { root: true });
            commit("SET_DISABLE_NEXT", true);
          }

          commit("SET_firstInResponse", elems[0]);
          commit("SET_lastInResponse", elems[elems.length - 1]);

          commit(
            "SET_pagination_clicked_count",
            self.state.Groupes.pagination_clicked_count++
          );
          self.state.Groupes.pagination_clicked_count++;
          commit("SET_DISABLE_PREV", false);
          //Push first item to use for Previous action
          let prev_start_at = this.state.Groupes.prev_start_at;
          prev_start_at.push(elems[0]);
          commit("SET_prev_start_at", prev_start_at);
          commit("SET_DISABLE_NEXT", false);
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("SET_DISABLE_NEXT", false);
        }
      );
  },

  async prevPage({ commit }) {
    let prev_start_at = this.state.Groupes.prev_start_at;
    if (prev_start_at.length > this.state.Groupes.pagination_clicked_count + 1)
      prev_start_at.splice(prev_start_at.length - 2, prev_start_at.length - 1);
    let get_prev_startAt =
      prev_start_at[this.state.Groupes.pagination_clicked_count - 1];
    //console.log(get_prev_startAt);
    let elems = [];
    let self = this;
    commit("SET_DISABLE_PREV", true);
    await this._vm.$firebase
      .firestore()
      .collection(this.state.Groupes.collection)
      .orderBy(this.state.Groupes.field)
      .startAt(get_prev_startAt.email)
      .endBefore(self.state.Groupes.firstInResponse.email)
      .limit(this.state.Groupes.paginationSize)
      .get()
      .then(
        (snapshot) => {
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          commit("SET_LISTE_GROUPES", elems);

          if (!elems.length) {
            let snack = {};
            snack.showSnackbar = true;
            snack.snackbarContent = "Pas d'éléments";
            commit("Snackbar/SET_SNACKBAR", snack, { root: true });
            commit("SET_DISABLE_NEXT", true);
          }

          commit("SET_firstInResponse", elems[0]);
          commit("SET_lastInResponse", elems[elems.length - 1]);

          //Maintaing page no.
          commit(
            "SET_pagination_clicked_count",
            self.state.Groupes.pagination_clicked_count--
          );
          self.state.Groupes.pagination_clicked_count--;

          //Pop not required value in array
          let prev_start_at = self.state.Groupes.prev_start_at;
          prev_start_at.forEach((element) => {
            if (elems[0].id == element.id) {
              element = null;
            }
          });
          commit("SET_prev_start_at", prev_start_at);

          //Enable buttons again
          commit("SET_DISABLE_PREV", false);
          commit("SET_DISABLE_NEXT", false);
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("SET_DISABLE_PREV", false);
        }
      );
  },

  async deleteGroupe({ commit }, entana) {
    let self = this;
    console.log("Groupe à supprimer: ", entana);

    await this._vm.$firebase
      .firestore()
      .collection("groupes")
      .doc(entana.id)
      .delete()
      .then(() => {
        console.log("Deleted : ", entana.id);
        /** delete membres */
        const MEMBRES = self._vm.$firebase.firestore().collection("membres");
        MEMBRES.where("id_groupe", "==", entana.id)
          .get()
          .then((snapshots) => {
            console.log("membres successfully deleted!");
            if (snapshots.size > 0) {
              snapshots.forEach((snap) => {
                MEMBRES.doc(snap.id).delete();
              });
            } else {
              console.log("no snap membres");
            }
          });
        /** END delete membres */
        /** delete dotationsDeGroupe */
        const dotationsDeGroupe = self._vm.$firebase
          .firestore()
          .collection("dotationsDeGroupe");
        dotationsDeGroupe
          .where("groupes_code_groupe", "==", entana.id)
          .get()
          .then((snapshots) => {
            if (snapshots.size > 0) {
              console.log("Dotations successfully deleted!");
              snapshots.forEach((snap) => {
                dotationsDeGroupe.doc(snap.id).delete();
              });
            } else {
              console.log("no snap dotationsDeGroupe");
            }
          });
        /** END delete dotationsDeGroupe */
        /** delete etapes_effectives */
        const etapes_effectives = self._vm.$firebase
          .firestore()
          .collection("etapes_effectives");
        etapes_effectives
          .where("groupes_id_groupe", "==", entana.id)
          .get()
          .then((snapshots) => {
            console.log("Etapes effectives successfully deleted!");
            if (snapshots.size > 0) {
              snapshots.forEach((snap) => {
                etapes_effectives.doc(snap.id).delete();
              });
            } else {
              console.log("no snap etapes_effectives");
            }
          });
        /** End delete etapes_effectives */
        /** delete formationsDeGroupe */
        const formationsDeGroupe = self._vm.$firebase
          .firestore()
          .collection("formationsDeGroupe");
        formationsDeGroupe
          .where("groupes_id_groupe", "==", entana.id)
          .get()
          .then((snapshots) => {
            console.log("Formations de Groupe successfully deleted!");
            if (snapshots.size > 0) {
              snapshots.forEach((snap) => {
                formationsDeGroupe.doc(snap.id).delete();
              });
            } else {
              console.log("no snap formationsDeGroupe");
            }
          });
        /** End delete formationsDeGroupe */
        /** delete parcours_effectif */
        const parcours_effectif = self._vm.$firebase
          .firestore()
          .collection("parcours_effectif");
        parcours_effectif
          .where("groupes_id_groupe", "==", entana.id)
          .get()
          .then((snapshots) => {
            if (snapshots.size > 0) {
              console.log("Parcours Effectifs successfully deleted!");
              snapshots.forEach((snap) => {
                parcours_effectif.doc(snap.id).delete();
              });
            } else {
              console.log("no snap parcours_effectif");
            }
          });
        /** End delete parcours_effectif */
        /** delete presencesFormationsGroupes */
        const presencesFormationsGroupes = self._vm.$firebase
          .firestore()
          .collection("presencesFormationsGroupes");
        presencesFormationsGroupes
          .where("groupes_id_groupe", "==", entana.id)
          .get()
          .then((snapshots) => {
            console.log("Presences Formations De groupe successfully deleted!");
            if (snapshots.size > 0) {
              snapshots.forEach((snap) => {
                presencesFormationsGroupes.doc(snap.id).delete();
              });
            } else {
              console.log("no snap presencesFormationsGroupes");
            }
          });
        /** End delete presencesFormationsGroupes */

        /** delete presencesDotationsGroupes */
        const presencesDotationsGroupes = self._vm.$firebase
          .firestore()
          .collection("presencesDotationsGroupes");
        presencesDotationsGroupes
          .where("groupes_id_groupe", "==", entana.id)
          .get()
          .then((snapshots) => {
            console.log("Presences Dotations De groupe successfully deleted!");
            if (snapshots.size > 0) {
              snapshots.forEach((snap) => {
                presencesDotationsGroupes.doc(snap.id).delete();
              });
            } else {
              console.log("no snap presencesDotationsGroupes");
            }
          });
        /** End delete presencesDotationsGroupes */

        /** delete fiches */
        const fiches = self._vm.$firebase.firestore().collection("fiches");
        fiches
          .where("groupes_id_groupe", "==", entana.id)
          .get()
          .then((snapshots) => {
            console.log("fiches De groupe successfully deleted!");
            if (snapshots.size > 0) {
              snapshots.forEach((snap) => {
                fiches.doc(snap.id).delete();
              });
            } else {
              console.log("no snap fiches");
            }
          });
        /** End delete fiches */
      })
      .catch((error) => {
        console.error("Error removing document: ", error);
      });
  },
};

const getters = {
  groupes: (state) => {
    return state.groupes;
  },

  disable_next: (state) => {
    return state.disable_next;
  },
  disable_prev: (state) => {
    return state.disable_prev;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
